import { Component, Input } from "@angular/core";
import { Subscription } from "rxjs";

import { Config } from "src/app/config";
import { ExamService } from "src/app/services/exam.service";
import { ServerResourcesPathPipe } from "src/app/pipe/serverresourcespath.pipe";
import { PageObjectEvaluation } from "src/app/models/pageobjectevaluation";
import { LibraryImage } from "src/app/models/libraryimage";
import { Exam } from "src/app/models/exam";

@Component({
  selector: "hkt-pageobjectevaluation",
  templateUrl: "./pageobjectevaluation.component.html",
  styleUrls: ["./pageobjectevaluation.component.scss"],
})
export class PageObjectEvaluationComponent {
  @Input("obj") obj: PageObjectEvaluation;
  @Input("mode") mode: string;

  exam: Exam;
  examSubscription: Subscription;
  editScore: boolean;
  scores: number[];
  oldZIndex: number;

  constructor(private examService: ExamService, private serverResourcesPathPipe: ServerResourcesPathPipe) {
    this.editScore = false;
    this.scores = [];
    this.oldZIndex = 0;
  }

  ngOnInit(): void {
    this.exam = this.examService.currentExam;
    this.examSubscription = this.examService.onCurrentExamChange.subscribe(exam => (this.exam = exam));

    for (let i = 0; i <= this.obj.score; i++) {
      this.scores.push(i);
    }
  }

  ngOnDestroy(): void {
    this.examSubscription.unsubscribe();
  }

  getSourceUrl(): string {
    let image: LibraryImage;

    if (!this.obj.evaluated) {
      if (this.mode == "edit") {
        if (this.obj.imageGood == "") {
          if (this.exam.style) {
            return "url('assets/" + this.exam.style + "-evaluation-admin.png')";
          } else {
            return "url('assets/evaluation_admin.png')";
          }
        } else {
          image = this.exam.library.getImage(this.obj.imageGood);
          if (image == null) {
            return "url('assets/notimage.png')";
          }
          return this.serverResourcesPathPipe.transform(image.source, Config.SERVER_UPLOADFOLDER, "background_url");
        }
      }
      return "";
    }

    if (this.obj.evaluationResult > 0) {
      if (this.obj.imageGood == "") {
        if (this.exam.style) {
          return "url('assets/" + this.exam.style + "-evaluation-good.png')";
        } else {
          return "url('assets/evaluation_good.png')";
        }
      } else {
        image = this.exam.library.getImage(this.obj.imageGood);
      }
    } else if (this.obj.evaluationResult == 0) {
      if (this.obj.imageBad == "") {
        if (this.exam.style) {
          return "url('assets/" + this.exam.style + "-evaluation-bad.png')";
        } else {
          return "url('assets/evaluation_bad.png')";
        }
      } else {
        image = this.exam.library.getImage(this.obj.imageBad);
      }
    } else if (this.obj.evaluationResult == -1) {
      if (this.exam.style) {
        return "url('assets/" + this.exam.style + "-evaluation-admin.png')";
      } else {
        return "url('assets/evaluation_admin.png')";
      }
    }

    if (image == null) {
      return "url('assets/notimage.png')";
    }

    return this.serverResourcesPathPipe.transform(image.source, Config.SERVER_UPLOADFOLDER, "background_url");
  }

  onClick(): void {
    if (this.mode != "evaluate") {
      return;
    }

    if (this.editScore) {
      this.obj.z = this.oldZIndex;
      this.editScore = false;
    } else {
      this.oldZIndex = this.obj.z;
      this.obj.z = 1000000;
      this.editScore = true;
    }
  }

  setScore(score): boolean {
    this.obj.evaluationResult = score;
    return false;
  }
}
